<template>
  <div class="content_box">
    <div class="news_title">
      <div class="news_h3">{{titleName}}</div>
    </div>
    <div class="file_list_box">
        <template v-if="showList && showList.length > 0">
            <div class="file_pdf_box">
              <div class="file_pdf_list" v-for="(item,index) in showList" :key="index"  @click="toDetailPage(item.msgUrl)">
                <div class="foundation_name">北京金山软件公益基金会</div>
                <div class="file_name">{{item.title}}</div>
                <div class="file_logo"><img src="../../../../src/assets/img/jjhlogo2.png"></div>
                <!--<div class="file_date">{{item.createDate}}</div>-->
              </div>
            </div>
        </template>
        <template v-else>
          <div class="nothing">
              <img src="../../../assets/img/nothing.png">
              <div class="no_word">暂无内容哦</div>
          </div>
      </template>
    </div>
    <div class="pageself" v-if="showList && showList.length > 0">
      <paginate
        :pageCount="pageCount"
        :containerClass="'pagination'"
        :page-range="3"
        :clickHandler="pageClick"
        :first-last-button="true"
        first-button-text="<<"
        last-button-text=">>"
        :prevText="'上一页'"
        :nextText="'下一页'"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleListView',
  components:{},
  props: {
    titleName:{
      type:String,
      default:''
    },
    messageList:{
      type:Array,
      default:[]
    },
    perPage:{
      type:Number,
      default:1
    },
    detailRouter:{
      type:String,
      default:''
    },
  },

  data () {
    return {
      
      showList:[],
      totalNum:0,
      pageCount:1,
      
    }
  },
  watch:{
    messageList(val){
        this.messageList = val;
        this.loadData();
    },
  },
  methods:{
    toDetailPage(msgUrl){
      //window.open(msgUrl,'_blank');
      this.$PageUtil.openNewPage(this,msgUrl)
    },
    
    pageClick(num){
      this.showList = this.$PageUtil.getStaticPage(num,this.perPage,this.messageList)
    },
    loadData(){
      
      this.totalNum = this.messageList.length;
      this.pageCount = this.$PageUtil.getPageCount(this.totalNum,this.perPage);
      //获得第一页数据
      this.showList = this.$PageUtil.getStaticPage(1,this.perPage,this.messageList);
    },
  },
  mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../../assets/css/ks_foundation.less';
    @import '../../../assets/css/ks_media.less';
    @import '../../../assets/fonts/iconfont.css';
    
</style>
